import React from 'react'

const Marker = ({color}) => {
  return (
      <svg viewBox="0 0 65 65">
          <path fill={color} d="M58.9,59.6l-7.3-14.7c-0.2-0.3-0.5-0.6-0.9-0.6H40.3c4.6-5.8,9.8-14.1,9.8-22.7C50.1,11.9,42.2,4,32.6,4
		s-17.5,7.9-17.5,17.6c0,8.6,5.1,17,9.8,22.7H14.3c-0.4,0-0.7,0.2-0.9,0.6L6.1,59.6c-0.2,0.3-0.1,0.7,0,1C6.3,60.8,6.7,61,7,61h51
		c0.3,0,0.7-0.2,0.8-0.5C59,60.2,59,59.9,58.9,59.6z M32.6,6c8.5,0,15.5,7,15.5,15.6c0,8.6-5.8,17.3-10.5,22.9
		c-0.2,0.1-0.4,0.3-0.5,0.5c-1.9,2.3-3.6,4-4.5,4.8c-3-2.9-15.5-15.6-15.5-28.2C17.1,13,24.1,6,32.6,6z M8.6,59l6.3-12.7h11.6
		c2.8,3.3,5.2,5.4,5.4,5.6c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.3-0.2,2.6-2.3,5.4-5.6h11.4L56.4,59H8.6z"/>
          <path fill={color} d="M39,21.5c0-3.6-2.9-6.5-6.5-6.5S26,17.9,26,21.5s2.9,6.5,6.5,6.5S39,25.1,39,21.5z M28,21.5
		c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5S35,26,32.5,26C30,26,28,24,28,21.5z"/>
      </svg>
  )
}

export default Marker
